// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__3jx9G","right":"styles_right__1a0Gg"};